/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
const UserProfileCardSection = ({ data, pageLanguageContent }) => {
	return (
		<div className='alert alert-info' role='alert'>
			<div className='cardText'>{pageLanguageContent['PRL075'] ? pageLanguageContent['PRL075'] : ''} </div>
			<div className='cardText' style={{ marginTop: '3px' }}>
				{pageLanguageContent['PRL076'] ? pageLanguageContent['PRL076'] : ''}
				<a target='_blank' rel='noopener noreferrer' href='https://welcome.amity.copiri.com'>
					{' '}
					<strong>https://welcome.amity.copiri.com </strong>
				</a>
			</div>
		</div>
	);
};
export default UserProfileCardSection;
